import React from "react";
import PropTypes from "prop-types";

import { Field, Control, Select, Icon } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SystemCodes from "./SystemCodes";
import { ErrorMessage } from "../ErrorMessage";

const SystemCodeIdSelect = ({
  category,
  value,
  label,
  size,
  name,
  onChange,
  icon,
  required,
  where,
  orderByMulti = ["CodeName_DESC"]
}) => (
  <Field>
    <SystemCodes
      variables={{
        where,
        orderByMulti
      }}
    >
      {({ data, loading, error }) => {
        if (error) return <ErrorMessage error={error} />;
        const codes = data ? data.SystemCodes : null;
        return codes ? (
          <Control iconLeft size={size}>
            <Select.Container
              fullwidth
              color={
                error || (required && (value === "" || value === "0"))
                  ? "danger"
                  : "secondary"
              }
              size={size}
              state={loading ? "loading" : null}
            >
              <Select
                disabled={!category || !category.length}
                name={name}
                value={value}
                onChange={onChange}
              >
                <Select.Option value={0}>{label}</Select.Option>
                {!loading &&
                  [...new Set(data.SystemCodes.map(c => c.CodeName))].map(
                    (CodeId, i) => (
                      <Select.Option
                        key={`system-code-id-select-${i}`}
                        value={CodeId}
                      >
                        {CodeId}
                      </Select.Option>
                    )
                  )}
              </Select>
            </Select.Container>
            {icon && (
              <Icon align="left" size={size}>
                <FontAwesomeIcon icon={icon} />
              </Icon>
            )}
          </Control>
        ) : null;
      }}
    </SystemCodes>
  </Field>
);

SystemCodeIdSelect.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  onChange: PropTypes.func,
  label: PropTypes.string,
  size: PropTypes.string,
  icon: PropTypes.string,
  category: PropTypes.string,
  required: PropTypes.bool,
  orderByMulti: PropTypes.array,
  where: PropTypes.object
};
SystemCodeIdSelect.defaultProps = {
  value: 0,
  icon: "globe"
};
export default SystemCodeIdSelect;
